import { createReducer, on } from '@ngrx/store';
import {
  ACCOUNT_FIND_SUCCESS,
  ACCOUNT_FAILURE,
  ACCOUNT_UPDATE_FORM,
  ACCOUNT_RESET_ERROR,
  ACCOUNT_RESET,
  ACCOUNT_RESET_FORM,
  ACCOUNT_FIND_ALL_SUCCESS,
  ACCOUNT_EDIT_MODE,
  ACCOUNT_CLEAR_STATE,
  ACCOUNT_UPDATE_ID,
  ACCOUNT_UPDATE_LOADING,
} from '../actions';
import { ResponseBadRequest } from '@core/interfaces';
import { Cuenta, CuentaForm, CuentaTable } from '@core/models';
import { transformAccountData, transformArrayAccountTable } from '@core/helpers';

export interface AccountState {
  loading: boolean;
  editMode: boolean;
  isEditing: boolean;
  accountId: string | null;
  account: Cuenta | null;
  accountList: Cuenta[];
  accountTableList: CuentaTable[];
  accountForm: CuentaForm | null;
  error: ResponseBadRequest | null;
}

export const initialState: AccountState = {
  loading: false,
  isEditing: false,
  editMode: false,
  accountId: null,
  account: null,
  accountList: [],
  accountTableList: [],
  accountForm: null,
  error: null,
};

export const accountReducer = createReducer(
  initialState,
  on(ACCOUNT_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(ACCOUNT_FIND_SUCCESS, (state, { account }) => ({ ...state, account: transformAccountData(account) })),
  on(ACCOUNT_FIND_ALL_SUCCESS, (state, { accountList }) => ({ ...state, accountList, accountTableList: transformArrayAccountTable(accountList) })),
  on(ACCOUNT_FAILURE, (state, { error }) => ({ ...state, error })),
  on(ACCOUNT_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(ACCOUNT_UPDATE_FORM, (state, { accountForm }) => ({ ...state, accountForm })),
  on(ACCOUNT_UPDATE_ID, (state, { accountId }) => ({ ...state, accountId })),
  on(ACCOUNT_RESET, (state) => ({ ...state, account: null, accountId: null, accountForm: null })),
  on(ACCOUNT_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(ACCOUNT_RESET_FORM, (state) => ({ ...state, accountForm: null, loading: false })),
  on(ACCOUNT_CLEAR_STATE, (state) => ({ ...initialState, loading: state.loading })),
);
